import React from 'react';
import { useLanguage } from '../context/LanguageContext';
export function Terms() {
  const {
    language
  } = useLanguage();
  const isIS = language === 'is';
  return <div className="min-h-screen bg-white" data-id="element-1742">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-id="element-1743">
        <h1 className="font-heading text-4xl font-bold text-charcoal mb-2" data-id="element-1744">
          {isIS ? 'Þjónustuskilmálar' : 'Terms of Service'}
        </h1>
        <p className="text-gray-400 text-sm mb-12" data-id="element-1745">
          {isIS ? 'Uppfært: janúar 2025' : 'Updated: January 2025'}
        </p>

        <div className="prose prose-gray max-w-none space-y-8 text-gray-600 leading-relaxed" data-id="element-1746">

          {isIS ? <>
              <section data-id="element-1747">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1748">Veitt þjónusta</h2>
                <p data-id="element-1749">Orgz ehf., kt. 630122-1650, veitir þjónustu á sviði leiðtogaþróunar, hópvinnu, lóðsunar og þjálfunar. Nákvæmt umfang hverrar þjónustu er skilgreint í samningi eða tilboðsbréfi sem liggur til grundvallar hverju verkefni.</p>
              </section>

              <section data-id="element-1750">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1751">Bókun og staðfesting</h2>
                <p data-id="element-1752">Þjónusta telst bókuð þegar skrifleg staðfesting hefur borist frá báðum aðilum, annaðhvort með tölvupósti eða undirritun samnings. Munnlegar fyrirætlanir eru ekki bindandi.</p>
              </section>

              <section data-id="element-1753">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1754">Greiðslur</h2>
                <p data-id="element-1755">Reikningur er sendur í kjölfar þjónustu nema um annað hafi verið samið. Greiðslufrestur er 20 dagar frá reikningsdegi. Við seinkun geta dráttarvextir verið lagðir á í samræmi við lög nr. 38/2001.</p>
              </section>

              <section data-id="element-1756">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1757">Afbókun</h2>
                <p data-id="element-1758">Afbókun sem berst meira en 7 dögum fyrir bókað tímamark er án gjalds. Afbókun innan 7 daga getur varðað 50% afbókunargjaldi. Afbókun innan 48 klukkustunda eða þegar þjónusta er hafin getur varðað fullum gjöldum. Hlutlægar ástæður (veikindi o.fl.) eru teknar til skoðunar í hverju tilviki.</p>
              </section>

              <section data-id="element-1759">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1760">Trúnaður</h2>
                <p data-id="element-1761">Öll samskipti og efni sem deilast í þjónustuferli eru meðhöndlað með fullum trúnaði. Orgz ehf. deilir hvorki persónulegum upplýsingum né innihaldi fundar eða þjálfunar með þriðja aðila án skriflegs samþykkis viðkomandi.</p>
              </section>

              <section data-id="element-1762">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1763">Höfundarréttur</h2>
                <p data-id="element-1764">Efni, verkfæri og aðferðir sem Orgz ehf. þróar og notar í þjónustu eru í eigu fyrirtækisins. Viðskiptavinur má nota efni til eigin nota en ekki endurselja eða nota í viðskiptalegum tilgangi án leyfis.</p>
              </section>

              <section data-id="element-1765">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1766">Ábyrgðarmörk</h2>
                <p data-id="element-1767">Orgz ehf. ber ekki ábyrgð á óbeinum tjónum eða afleiddum skaða sem kann að stafa af þjónustu. Hámarksábyrgð er takmörkuð við þá fjárhæð sem greidd hefur verið fyrir viðkomandi þjónustu.</p>
              </section>

              <section data-id="element-1768">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1769">Gildandi lög</h2>
                <p data-id="element-1770">Þessir skilmálar lúta íslenskum lögum. Ágreiningur sem rís úr þjónustu þessari skal leystur við Héraðsdóm Reykjavíkur.</p>
              </section>

              <section data-id="element-1771">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1772">Samband</h2>
                <p data-id="element-1773">Spurningar um þjónustuskilmála sendist á helgi@orgz.is.</p>
              </section>
            </> : <>
              <section data-id="element-1774">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1775">Services provided</h2>
                <p data-id="element-1776">Orgz ehf., registration no. 630122-1650, provides services in leadership development, team facilitation, and training. The scope of each engagement is defined in the proposal or contract agreed between the parties.</p>
              </section>

              <section data-id="element-1777">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1778">Booking and confirmation</h2>
                <p data-id="element-1779">A booking is confirmed when written agreement has been received from both parties, either by email or signed contract. Verbal arrangements are not binding.</p>
              </section>

              <section data-id="element-1780">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1781">Payment</h2>
                <p data-id="element-1782">Invoices are issued following delivery of services unless otherwise agreed. Payment terms are 20 days from invoice date. Late payments may be subject to statutory interest under Icelandic Act no. 38/2001.</p>
              </section>

              <section data-id="element-1783">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1784">Cancellation</h2>
                <p data-id="element-1785">Cancellations received more than 7 days before the scheduled date are free of charge. Cancellations within 7 days may incur a 50% cancellation fee. Cancellations within 48 hours or after commencement may be charged in full. Objective circumstances (illness etc.) are considered case by case.</p>
              </section>

              <section data-id="element-1786">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1787">Confidentiality</h2>
                <p data-id="element-1788">All communication and content shared during service delivery is treated in strict confidence. Orgz ehf. does not share personal information or session content with third parties without written consent.</p>
              </section>

              <section data-id="element-1789">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1790">Intellectual property</h2>
                <p data-id="element-1791">Materials, tools, and methods developed and used by Orgz ehf. remain the property of the company. Clients may use materials for their own purposes but may not resell or use them commercially without permission.</p>
              </section>

              <section data-id="element-1792">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1793">Limitation of liability</h2>
                <p data-id="element-1794">Orgz ehf. is not liable for indirect or consequential losses arising from services provided. Maximum liability is limited to the amount paid for the relevant service.</p>
              </section>

              <section data-id="element-1795">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1796">Governing law</h2>
                <p data-id="element-1797">These terms are governed by Icelandic law. Disputes arising from these services shall be resolved at the District Court of Reykjavík.</p>
              </section>

              <section data-id="element-1798">
                <h2 className="font-heading text-xl font-bold text-charcoal mb-3" data-id="element-1799">Contact</h2>
                <p data-id="element-1800">Questions about these terms: helgi@orgz.is.</p>
              </section>
            </>}
        </div>
      </div>
    </div>;
}